import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SieniService } from 'src/app/shared/services/sieni.service';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss']
})
export class ModalConfirmComponent implements OnInit {

    @Input() title: any;

    @Output() clickClose = new EventEmitter();
    @Output() clickDismiss = new EventEmitter();

    constructor(
        public activeModal: NgbActiveModal,
        public translate: TranslateService,
        public _globalService: SieniService
    ) { }

    ngOnInit() {
        this.translate.use(this._globalService.user.language.code)
    }

    btnClose() {
        this.clickClose.emit('save');
        this.activeModal.close();
    }

    btnDismiss() {
        this.clickDismiss.emit('dismiss');
        this.activeModal.dismiss();
    }
}
